import { useTranslation } from "react-i18next";
import ToolTip from "../../tooltip";

const ModTooltip = ({ preferredLoadInput }) => {
  const { t } = useTranslation("coaching-portal");
  if (preferredLoadInput !== "drop") return null;

  return (
    <ToolTip
      id="load-mod-tooltip"
      body={t("addExerciseModal.modTooltipBody")}
    >
      <span className="load-mod-tooltip">?</span>
    </ToolTip>
  );
};

export default ModTooltip;
